import pricingService from "../utils/services/pricingService";

const state = {
  prices: {}
};
const getters = {
  getPrices(state) {
    return state.prices;
  }
};

const actions = {
  getCosts(_, { params = {}, onSuccess = () => {} }) {
    return pricingService.getCosts(params, ({ data }) => {
      onSuccess({ data });
      return data;
    });
  },
  getPrices({ commit }, { params = {}, onSuccess = () => {} }) {
    return pricingService.getPrices(params, ({ data }) => {
      commit("setPrices", {
        data
      });
      onSuccess({ data });
    });
  }
};

const mutations = {
  setPrices(state, { data }) {
    state.prices = data;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
